module.exports = __webpack_public_path__ + "static/media/heaterlux-3.2c419b61.jpg";